
<template>
  <v-layout>
    <v-flex id="lala" xs12 sm6 offset-sm3 class="scrollable">
      <!-- <v-flex class="scrollable pl-1 pr-2"> -->
      <h4 class="mt-4">{{$translate('NAME')}}</h4>
      <v-textarea
        rows="1"
        auto-grow
        class="mb-4"
        :label="$translate('EVENT_NAME')"
        v-model="eventForm2.name"
        outline
        hide-details
        item-text="label"
        item-value="value"
        ref="eventForm"
      />
      <v-checkbox
        v-model="eventForm2.main"
        :label="$translate('MAIN_EVENT')"
        hide-details
        class="mb-2"
        item-text="label"
        item-value="value"
        ref="eventform"
      ></v-checkbox>
      <h4 class="mt-4"></h4>
      <v-text-field
        rows="1"
        auto-grow
        type="number"
        min="0"
        step="1"
        class="mb-4"
        :label="$translate('EVENT_CAPACITY')"
        v-model="eventForm2.maxEventCapacity"
        outline
        hide-details
        item-text="label"
        item-value="value"
        ref="eventForm"
      />

      <h4 class="mt-3">{{$translate('EVENT_DESC_SHORT')}}</h4>
      <v-textarea
        rows="3"
        auto-grow
        class="mb-4"
        :label="$translate('EVENT_DESCRIPTION')"
        v-model="eventForm2.description"
        outline
        hide-details
        item-text="label"
        item-value="value"
        ref="eventForm"
      />
      <h4>{{$translate('ARRIVAL_TEXT_MSG')}}</h4>
      <v-textarea
        rows="1"
        auto-grow
        class="mb-4"
        v-model="eventForm2.arrivalText"
        outline
        hide-details
        :label="$translate('ARRIVAL_TEXT_MSG')"
        ref="eventForm"
      />
      <audio-loader :properties="audioProp1" v-on:selectAudio1Element="setAudioElement"></audio-loader>
      <h4 class="mt-4">{{$translate('DEPARTURE_TEXT_MSG')}}</h4>
      <v-textarea
        rows="1"
        auto-grow
        class="mb-4"
        v-model="eventForm2.departureText"
        outline
        hide-details
        :label="$translate('DEPARTURE_TEXT_MSG')"
        ref="eventForm"
      />
      <audio-loader :properties="audioProp2" v-on:selectAudio2Element="setAudioElement"></audio-loader>

      <h4 class="mt-4">{{$translate('EVENT_PIC_SHORT')}}</h4>
      <label v-if="eventForm2.picture" for="picture-upload" slot="append">
        <img
          style="cursor:pointer;"
          :src="eventForm2.picture"
          height="150"
          class="maxProperties"
          v-if="eventForm2.picture"
        >
      </label>
      <label v-if="!eventForm2.picture" for="picture-upload" slot="append">
        <v-icon class="addIcon" color="primary" slot="append">add</v-icon>
      </label>
      <v-text-field
        style="display: none"
        id="picture-upload"
        :label="$translate('UPLOAD_IMAGE')"
        @click="pickFile"
        v-model="eventForm2.imageName"
        outline
      ></v-text-field>
      <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked">
      <v-icon v-if="eventForm2.picture" @click="clearImage">clear</v-icon>
      <h4 class="mt-4">{{$translate('ADD_TAGS')}}</h4>
      <v-select
        multiple
        class="mb-2 tagBox"
        v-model="eventForm2.tags"
        :items="tags"
        color="primary"
        item-text="Description"
        item-value="TagId"
        outline
        hide-details
        ref="eventForm"
      ></v-select>

      <v-select
        chips
        :label="$translate('VISIBILITY')"
        v-model="userGroupsSelected"
        :items="userGroups"
        item-text="userGroupName"
        item-value="userGroupId"
        class="mr-2 ml-2"
        persistent-hint
        return-object
        clearable
        multiple
      ></v-select>
      <v-layout row justify-center class="mt-4">
        <v-flex xs6>
          <v-tooltip right>
            <v-btn
              round
              slot="activator"
              color="primary"
              class="v-btn-5 dialogButton"
              @click="sendEventDescForm"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <span>{{$translate('SAVE')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import CreateEventObject2 from "../objects/CreateEventObject2.js";
import appConfig from "../../config/app_config";
import * as dssRequest from "../api/dssRequest";
import BatchGroupObject from "../objects/BatchGroupObject.js";
import { mapGetters } from "vuex";
import { objectToArray } from "../shared/utility.js";
import _ from "lodash";
import AudioLoader from "./media/AudioLoader";
import BaseObject from "../objects/BaseObject";
import BaseComponent from "./base/BaseComponent.vue";

export default {
  extends: BaseComponent,
  name: "EventView_Main",

  props: {
    objId: String
  },
  computed: {
    ...mapGetters({
      tags: "getAllTags"
    })
  },
  components: {
    AudioLoader
  },
  created() {
    // this.getUserGroups();
  },

  beforeDestroy() {
  },
  data() {
    return {
      userGroups: [],
      userGroupsSelected: [],
      eventForm2: CreateEventObject2._objectDefinition(),
      eventDescription: [],
      imageName: "",
      imageUrl: "",
      departureAudioName: "",
      arrivalAudioName: "",
      audioProp2: {
        title: "Departure audio message",
        signalName: "selectAudio2Element",
        audioName: "",
        audioUrl: ""
      },
      audioProp1: {
        title: "Arrival audio message",
        signalName: "selectAudio1Element",
        audioName: "",
        audioUrl: ""
      }
    };
  },
  methods: {
    setAudioElement(d) {
      if (d.signalName !== undefined) {
        if (d.signalName === "selectAudio1Element") {
          this.eventForm2.arrivalAudioUrl = d.url;
          this.eventForm2.arrivalAudio = d.url;
        } else if (d.signalName === "selectAudio2Element") {
          this.eventForm2.departureAudioUrl = d.url;
          this.eventForm2.departureAudio = d.url;
        }
      }
    },
    manageDataForComponent(data) {

      this.eventForm2 = data;
      if (!_.isEmpty(data)) {
        this.userGroupsSelected = [];
        if (
          this.eventForm2.memberOf !== undefined &&
          this.eventForm2.memberOf.length > 0
        ) {
          this.eventForm2.memberOf.forEach(e => {
            if (e.grantType === "VISIBLE") {
              this.userGroupsSelected.push(e);
            }
          });
        }

        const copy = this.eventForm2.tags;
        this.eventForm2.tags = [];
        for (let [k, v] of Object.entries(copy)) {
          if (v.Selected == "yes") {
            let id = v.TagId;
            this.eventForm2.tags.push(v);
          }
        }
        console.log("event form 2 tags" , this.eventForm2.tags)
        this.audioProp2.audioName = data.departureText;
        this.audioProp2.audioUrl = data.departureAudio;
        this.audioProp1.audioName = data.arrivalText;
        this.audioProp1.audioUrl = data.arrivalAudio;
      } else {
        this.eventForm2 = CreateEventObject2._objectDefinition();
        this.audioProp1.audioName = "";
        this.audioProp1.audioUrl = "";
        this.audioProp2.audioName = "";
        this.audioProp2.audioUrl = "";
      }
    },

    clearImage() {
      this.eventForm2.imageUrl = "";
      this.eventForm2.picture = "";
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const maxSize = appConfig.maxSize.pictureSize;
      const files = e.target.files;
      if (files[0].size > maxSize) {
        window.EventBus.fire(
          "activateSnackBar",
          "File can't be bigger than 1MB"
        );
        return;
      }
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0];
          this.eventForm2.picture = this.imageUrl;
          // debugger;
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
        this.eventForm2.picture = "";
      }
    },
    sendSignalToGetEvents() {
      let toSendData = {};
      toSendData.LocationId = this.objId;
      window.EventBus.fire("getEventsBasedOnUserLevel", toSendData);
    },
    sendEventDescForm() {

      // TODO: Verify form is not attempting to submit empty defaults...
      let formVerified = true;

      if (formVerified) {
        this.eventForm2.owner = this.userName;
        this.eventForm2.locationId = this.objId;

        let payload = CreateEventObject2._createRequestObject(
          this.eventForm2,
          this.userGroupsSelected
        );
        payload.FunctionId = "EventFunctionLibrary::saveEvent";

        dssRequest.doRequest(
          response => {
            console.log("The generic call saveEvent was successful", response);
            window.EventBus.fire(
              "activateSnackBar",
              "Event Description is stored successfully !"
            );
            this.sendSignalToGetEvents();
          },
          error => {
            console.log(
              "The generic call saveEvent was not successful",
              error
            );
          },
          "communicateWithDBLibrary",
          this.currentAccountId,
          payload
        );
      } else {
      }
    }
  }
};
</script>
<style>
.scrollable {
  height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.mb {
  margin-bottom: 0px;
}
.v-btn-5 {
  min-width: 1em;
}
</style>
